export const getFormattedDate = (dateMilis: number) => {
    const actualDate = new Date(0)
    actualDate.setUTCMilliseconds(dateMilis)
    const hours: string | number = actualDate.getHours()
    let minutes: string | number = actualDate.getMinutes()
    minutes = minutes < 10 ? `0${String(minutes)}` : String(minutes)
    const finalProgramTime = `${hours}:${minutes}`

    return finalProgramTime
}

export const getNumericWeekDay = (epochDate: number) => {
    const date = new Date(epochDate)
    const weekdayNumeric = date.getDay()
    return weekdayNumeric
}

export const getDDMMRRdate = (epochDate: number) => {
    const date = new Date(epochDate)
    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0') // Month is 0-indexed
    const year = String(date.getFullYear())
    const DDMMRR = ` ${day}.${month}.${year}`
    return DDMMRR
}

export const mangleDateFormatter = (epochDate: number) => {
    const actualDate = String(new Date())
    const dateToConvert = String(new Date(epochDate))
    const actualDateParts = actualDate.split(' ')
    const dateToConvertParts = dateToConvert.split(' ')

    dateToConvertParts[0] = actualDateParts[0]
    dateToConvertParts[1] = actualDateParts[1]
    dateToConvertParts[2] = actualDateParts[2]

    const convertedDate = new Date(dateToConvertParts.join(' '))
    const epochConvertedDate = convertedDate.getTime()
    return epochConvertedDate
}
